var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDefaultProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "User Icon"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    cx: 22,
    cy: 22,
    r: 22,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_276",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Mask",
    cx: 22,
    cy: 22,
    r: 22,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_276)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Head",
    cx: 22,
    cy: 14,
    r: 8,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Body",
    d: "M38 38C38 46.8366 30.8366 44 22 44C13.1634 44 6 46.8366 6 38C6 29.1634 13.1634 22 22 22C30.8366 22 38 29.1634 38 38Z",
    fill: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefaultProfile);
export default __webpack_public_path__ + "static/media/icon_default_profile.e01228dc6097db4aaf6611b8e552733e.svg";
export { ForwardRef as ReactComponent };